<template>
    <div class="paperPriace ">
        <page-header></page-header>
        <div class="contain xy-between">
          <div class="topicList" v-if="false">
            <div class="topicItem" v-for="(orginObj,i) in dataList" :key="i">
                 <div class="topicContain" v-if="orginObj">
            <div class="topicNav ">
              <div class="tit ">
                <div class="font-size14 topicType c-256CF4">
                  [{{orginObj.SubjectType === "1" ?  "单选题" : orginObj.SubjectType === "2" ? "多选题" : orginObj.SubjectType === "3" ?
                  "填空题" : orginObj.SubjectType === "4" ? "判断题" : orginObj.SubjectType === "5" ? "问答题" :orginObj.SubjectType === "6" ?  "复合题" : ""}}]
                </div>
                <div class="font-size18 topicContent" v-if="orginObj.stem" v-html="orginObj.stem"></div>
              </div>
              <div @click="collection">

                <i v-if="!parseInt(orginObj.collect)" class="iconfont icon-shoucang font-size24 c-E5E8EC"></i>
                <i v-else class="iconfont icon-shoucang font-size24 c-FFD251"></i>
              </div>
            </div>
            <div class="allTopics">
              <!-- 单选题 -->
              <div class="sigleSelect " v-if="orginObj.SubjectType === '1'">
                <div class="topics">
                  <div class="topicItem jf" v-for="(singleItem,index) in orginObj.answer" :key="index">
                    <div class="options xy-center cursor multiple " v-html="singleItem.option"
                      :class="{'singleActive' : singleItem.rankStyle,'makeRightStyle'  : singleItem.origlRight,'isErrorActive' : singleItem.userIsErrStyle}"
                      @click="selectSingleAnswer(singleItem,orginObj.answer)"> </div>
                    <div class="content  font-size14" v-html="singleItem.content"></div>
                  </div>
                </div>
                <div>
                  <div v-if="orginObj.status" class="parsingBox">
                    <div class="showAnswerText xy-between">
                      <div class="lfet jf">
                        <div class="right jf">
                          正确答案：
                          <div class="c-00B37C font-size18" v-for="(singleItem,index) in orginObj.answer" :key="index">
                            <div class="" v-if="singleItem.rightFlag === '1'">
                              <div v-html="singleItem.option"></div>
                            </div>
                          </div>
                        </div>
                        <div class="your jf">
                          您的答案：
                          <div  class="c-F33737 font-size18">{{ this.orginObj.SubjectAnswer ? this.orginObj.SubjectAnswer    :""}}
                          </div>
                          <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                        </div>
                      </div>
                      <div class="right">
                        <!-- 纠错 -->
                      </div>
                    </div>
                    <div class="parsing">
                      <div class="tit jf">
                        <div class="cyc"></div>
                        <div class="text c-72777F">解析</div>
                      </div>
                      <div>
                        <div class="text" v-if="orginObj.analysis" v-html="orginObj.analysis">
                        </div>
                        <div v-else class="text">暂无解析</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="notParsingBox">

                  </div>
                </div>
              </div>
              <!-- 多选题 -->
              <div class="multiSelect " v-else-if="orginObj.SubjectType === '2'">
                <div class="topics">
                  <div class="topicItem jf" v-for="(singleItem,index) in orginObj.answer" :key="index">
                    <div class="options xy-center cursor multiple " v-html="singleItem.option"
                      :class="{'singleActive' : singleItem.rankStyle,'makeRightStyle'  : singleItem.origlRight,'isErrorActive' : singleItem.userIsErrStyle}"
                      @click="selectSomeAnswer(singleItem,orginObj.answer)"> </div>
                    <div class="content  font-size14" v-html="singleItem.content"></div>
                  </div>
                </div>
                <div>
                  <div v-if="orginObj.status" class="parsingBox">
                    <div class="showAnswerText xy-between">
                      <div class="lfet jf">
                        <div class="right jf">
                          正确答案：
                          <div class="c-00B37C font-size18" v-for="(singleItem,index) in orginObj.answer" :key="index">
                            <div class="" v-if="singleItem.rightFlag === '1'">
                              <div v-html="singleItem.option"></div>
                            </div>
                          </div>
                        </div>
                        <div class="your jf">
                          您的答案：
                          <div  class="c-F33737 font-size18">{{ this.orginObj.SubjectAnswer ? this.orginObj.SubjectAnswer    :""}}</div>
                          <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                        </div>
                      </div>
                      <div class="right">
                        <!-- 纠错 -->
                      </div>
                    </div>
                    <div class="parsing">
                      <div class="tit jf">
                        <div class="cyc"></div>
                        <div class="text c-72777F">解析</div>
                      </div>
                      <div>
                        <div class="text" v-if="orginObj.analysis" v-html="orginObj.analysis">
                        </div>
                        <div v-else class="text">暂无解析</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="notParsingBox">

                  </div>
                </div>
              </div>
              <!-- 填空题 -->
              <div class="fillBlank" v-else-if="orginObj.SubjectType === '3'">

                <div class="fillBlankItem" v-for="(singleItem,index) in orginObj.answer" :key="index">
                  <div class="font-size14 c-333333 fillBlanktext">填空{{index+1}}</div>
                  <div class="fillBlankField">
                    <el-input v-if="!orginObj.status" resize="none" :readonly="isReadonly" v-model="fillAnswer"
                      @input="testFill" rows="1" autosize type="textarea" placeholder="请在此输入您的答案"></el-input>
                    <el-input v-else readonly v-model="orginObj.SubjectAnswer" rows="1" autosize type="textarea"
                      placeholder="答案"></el-input>
                  </div>
                </div>
                  <div class="confrimBtn xy-center font-size16 cursor" @click="cofrimFill">
                  确定
                </div>
                    <div v-if="orginObj.status" class="parsingBox">
                    <div class="showAnswerText xy-between">
                      <div class="lfet jf">
                        <div class="right ">
                         <div  style="margin-bottom:20px;color:#00B37C">正确答案：</div>
                          <div v-for="(singleItem,index) in orginObj.answer" :key="index">
                            <div v-html="singleItem.content"></div>
                          </div>
                        </div>

                      </div>
                      <div class="right">
                        <!-- 纠错 -->
                      </div>
                    </div>
                    <div class="parsing">
                      <div class="tit jf">
                        <div class="cyc"></div>
                        <div class="text c-72777F">解析</div>
                      </div>
                      <div>
                        <div class="text" v-if="orginObj.analysis" v-html="orginObj.analysis">
                        </div>
                        <div v-else class="text">暂无解析</div>
                      </div>
                    </div>
                  </div>

              </div>
              <!-- 判断题 -->
              <div class="judgeTopic " v-else-if="orginObj.SubjectType === '4'">
                   <div class="topics">
                  <div class="topicItem jf" v-for="(singleItem,index) in orginObj.answer" :key="index">
                    <div class="options xy-center cursor multiple " v-html="singleItem.option"
                      :class="{'singleActive' : singleItem.rankStyle,'makeRightStyle'  : singleItem.origlRight,'isErrorActive' : singleItem.userIsErrStyle}"
                      @click="selectSingleAnswer(singleItem,orginObj.answer)"> </div>
                    <div class="content  font-size14" v-html="singleItem.content"></div>
                  </div>
                </div>
                <div>
                  <div v-if="orginObj.status" class="parsingBox">
                    <div class="showAnswerText xy-between">
                      <div class="lfet jf">
                        <div class="right jf">
                          正确答案：
                          <div class="c-00B37C font-size18" v-for="(singleItem,index) in orginObj.answer" :key="index">
                            <div class="" v-if="singleItem.rightFlag === '1'">
                              <div v-html="singleItem.option"></div>
                            </div>
                          </div>
                        </div>
                        <div class="your jf">
                          您的答案：
                          <div  class="c-F33737 font-size18">{{ this.orginObj.SubjectAnswer ? this.orginObj.SubjectAnswer    :""}}
                          </div>
                          <!-- <div v-else class="c-F33737 font-size18">正确</div> -->
                        </div>
                      </div>
                      <div class="right">
                        <!-- 纠错 -->
                      </div>
                    </div>
                    <div class="parsing">
                      <div class="tit jf">
                        <div class="cyc"></div>
                        <div class="text c-72777F">解析</div>
                      </div>
                      <div>
                        <div class="text" v-if="orginObj.analysis" v-html="orginObj.analysis">
                        </div>
                        <div v-else class="text">暂无解析</div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="notParsingBox">

                  </div>
                </div>
              </div>
              <!-- 简答题 -->
              <div class="shortAnswer" v-else-if="orginObj.SubjectType === '5'">
                  <div class="fillBlankItem" v-for="(singleItem,index) in orginObj.answer" :key="index">
                  <!-- <div class="font-size14 c-333333 fillBlanktext">填空{{index+1}}</div> -->
                  <div class="fillBlankField">
                    <el-input v-if="!orginObj.status" resize="none" :readonly="isReadonly" v-model="fillAnswer"
                      @input="testFill" rows="1" autosize type="textarea" placeholder="请在此输入您的答案"></el-input>
                    <el-input v-else readonly v-model="orginObj.SubjectAnswer" rows="1" autosize type="textarea"
                      placeholder="答案"></el-input>
                  </div>
                </div>
                  <div class="confrimBtn xy-center font-size16 cursor" @click="cofrimFill">
                  确定
                </div>
                    <div v-if="orginObj.status" class="parsingBox">
                    <div class="showAnswerText xy-between">
                      <div class="lfet jf">
                        <div class="right ">
                         <div  style="margin-bottom:20px">正确答案：</div>
                          <div v-for="(singleItem,index) in orginObj.answer" :key="index">
                            <div v-html="singleItem.content"></div>
                          </div>
                        </div>

                      </div>
                      <div class="right">
                        <!-- 纠错 -->
                      </div>
                    </div>
                    <div class="parsing">
                      <div class="tit jf">
                        <div class="cyc"></div>
                        <div class="text c-72777F">解析</div>
                      </div>
                      <div>
                        <div class="text" v-if="orginObj.analysis" v-html="orginObj.analysis">
                        </div>
                        <div v-else class="text">暂无解析</div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
            </div>
          </div>
          <div class="sheet">

          </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/header";
import {
    GetRandomExam
} from "@/api/exam";

export default {
    components: {
        PageHeader
    },
    data() {
        return {
            passId: "7394c9b9f904499485a48e1f6dc1f77e",
            dataList: []
        }
    },
    created() {
        // this.passId = this.$route.query.id;
        this.GetRandomExam(this.passId)
    },
    beforeDestroy() {
    },
    methods: {
    }
}

</script>

<style scoped lang="less">
.paperPriace{
  width: 100%;
  .contain{
    width: 62.5%;
    margin: 0 auto;
    background-color:white;
    .topicList{
      width: 600px;
      height: 600px;
      background-color: pink;
    }
    .sheet{
     width: 200px;
      height: 600px;
       background-color: pink;
    }
  }
}

</style>
